import { Link } from 'react-router-dom';

interface CategoryCardProps {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export default function CategoryCard({ name, slug, icon, description }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col items-center p-6 rounded-xl bg-background-100 hover:bg-background-200 border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
    >
      <div className="w-14 h-14 rounded-full bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
        <i className={`${icon} text-primary-500 text-2xl w-6 h-6 flex items-center justify-center`}></i>
      </div>
      <h3 className="text-foreground-100 font-medium text-sm mb-1 whitespace-nowrap">{name}</h3>
      <p className="text-foreground-500 text-xs text-center">{description}</p>
    </Link>
  );
}